import LabDateInfo from "./LabDateInfo";
export default LabDateInfo;
